export default __webpack_public_path__ + "static/media/5.b7778a5f.webp";